export interface SalesInvoiceHeaderPosting {
  id: string;
  invoiceNo: number;
  dateInvoiced: Date;
  customerKey: string;
  customerName: string;
  currencyCode: string;
  nettTotal: string;
  deliveryTotal: string;
  extraTotal: string;
  taxTotal: string;
  overallTotal: string;
}
